import { startCase } from 'lodash';

import KeywordPreview from 'features/clients/Client/Account/Advertising/CampaignType/components/KeywordPreview';
import TargetPreview from 'features/clients/Client/Account/Advertising/CampaignType/components/TargetPreview';

import { currencyFormatter } from 'utils/formatters';

const ConvertAsNegativeKeyword = ({ items }) => {
  return (
    <table className="min-w-full divide-y divide-gray-200">
      <thead className="bg-gray-50">
        <tr>
          <th
            scope="col"
            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
          >
            Search Term
          </th>
          <th
            scope="col"
            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
          >
            Target
          </th>
          <th
            scope="col"
            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
          >
            Convert as
          </th>
        </tr>
      </thead>

      <tbody className="bg-white divide-y divide-gray-200">
        {items.map((item) => (
          <tr key={item.advOptimizationReportItemId}>
            <td className="px-6 py-4 whitespace-nowrap text-xs text-gray-500">
              {item.values.query}
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-xs text-gray-600">
              {item.values.target === 'keyword' ? (
                <KeywordPreview
                  adGroupName={item.values.adGroup.name}
                  campaignName={item.values.campaign.name}
                  keywordText={item.values.keywordTargeting.keywordText}
                  matchType={item.values.keywordTargeting.matchType}
                  bid={currencyFormatter(item.values.keywordTargeting.bid)}
                />
              ) : (
                <TargetPreview
                  adGroupName={item.values.adGroup.name}
                  campaignName={item.values.campaign.name}
                  targetingText={item.values.productTargeting.targetingText}
                />
              )}
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-xs text-gray-500">
              {startCase(item.selectedOption.rule.actionData.matchType)} in{' '}
              {startCase(
                item.selectedOption.rule.actionData.level.slice(0, -1)
              )}{' '}
              level
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ConvertAsNegativeKeyword;
